
class Resources {
    APP_NAME = "";
    BACKEND_SIDE_BASE_URL = "https://api.mtlcdn.com/facial-recognition-hrm" ;
}

export default Resources;